import React from 'react'
import styled from '@emotion/styled'
import RatingGroup from './rating-group'
import ProductMiniCard from './product-mini-card'

const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid #eee;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #ddd;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 8px;
`

const ProductTextarea = styled.textarea`
  width: 100%;
  padding: 10px;
  min-height: 80px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 8px;
  resize: vertical;
  font-size: 14px;
`

export default function ProductRatingCard({
  name,
  image,
  accuracy,
  quality,
  text,
  onAccuracyChange,
  onQualityChange,
  onReviewChange,
}) {
  return (
    <Card>
      <ProductMiniCard image={image} name={name} nameOnly />

      <Content>
        <RatingGroup
          direction='row'
          label='Akurasi Produk'
          value={accuracy}
          onChange={onAccuracyChange}
        />

        <RatingGroup
          direction='row'
          label='Kualitas Produk'
          value={quality}
          onChange={onQualityChange}
        />

        <ProductTextarea
          placeholder='Tulis ulasan untuk produk ini (opsional)…'
          value={text}
          onChange={e => onReviewChange(e.target.value)}
        />
      </Content>
    </Card>
  )
}
